// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2038":"2c628262ea4300a9","9019":"c64cce4e50064bb3","9715":"b7cb5ad5dfdc9714"}[chunkId] + ".css";
};